import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PeriodSelector } from './PeriodSelector';
import { getPreviousPeriods } from '../../lib/utils';

/**
 * Selector compacto de mes/período para solapas operativas.
 * Layout: [<] [Selector] [>]  + slot opcional `right` (filtros u otros controles).
 * Sin título ni subtítulo: el período ya se ve en el selector.
 *
 * Props:
 *  - value: período YYYY-MM
 *  - onChange: setter
 *  - right: contenido inline a la derecha (filtros, indicadores)
 *  - testid: id base para data-testid
 */
export const MonthPeriodHeader = ({ value, onChange, right, testid = 'foresta-month-header' }) => {
  const periods = getPreviousPeriods(24);
  const currentIndex = periods.indexOf(value);

  const goPrev = () => { if (currentIndex < periods.length - 1) onChange(periods[currentIndex + 1]); };
  const goNext = () => { if (currentIndex > 0) onChange(periods[currentIndex - 1]); };

  return (
    <div className="flex flex-wrap items-center gap-2 mb-2" data-testid={testid}>
      <div className="flex items-center gap-1 shrink-0">
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          onClick={goPrev}
          disabled={currentIndex >= periods.length - 1}
          data-testid={`${testid}-prev`}
          title="Mes anterior"
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <div className="w-[160px]">
          <PeriodSelector value={value} onChange={onChange} placeholder="Período" />
        </div>
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          onClick={goNext}
          disabled={currentIndex <= 0}
          data-testid={`${testid}-next`}
          title="Mes siguiente"
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
      {right && <div className="flex flex-wrap items-center gap-2 flex-1">{right}</div>}
    </div>
  );
};

export default MonthPeriodHeader;
